package com.ustadmobile.core.impl.nav

data class NavResult(
    val key: String,
    val timestamp: Long,
    val result: Any?
) {


}